<form ngNativeValidate #generateResumeForm="ngForm" class="login-form container-fluid center" (submit)="generateResume(); generateResumeForm.reset();">
  <br />
  <h1>Upload your Resume to Create your Free Webpage</h1>
  <br />
  <input type="text" class="default form-control resume-name" placeholder="Your Name" [(ngModel)]="id" name="id" required autofocus />
  <br />
  <br />
  <input type="file" (change)="onFileSelected($event)" class="default form-control resume-file" placeholder="Your Resume" [(ngModel)]="resume" name="resume" required /> <!--//jeb only docx? or does pdf work etc? -->
  <br />
  <!--//jeb make this a color choice? <input type="password" class="default form-control login-password" placeholder="Password" [(ngModel)]="password" name="password" required />-->
  <br />
  <button type="submit" class="red-pill animated fadeInUp" title="Generate Resume Webpage">
    <!--//jeb need validation and dupe check-->
    Generate Webpage
  </button>
  <br />
  <br />
  <div>(After Clicking, Remember to Bookmark your New Webpage!)</div>
  <br />
  <br />
  <div class="row section-top center animated fadeInUp">
    <a class="blue-pill" href="https://jessebooth.com">
      See an Example
    </a>
    <br class="mobile-show" />
    <br class="mobile-show" />
    <a class="blue-pill" href="https://www.matrix.tools/resumes" title="Nashville Digital Marketing Agency">
      See the Directory
    </a>
  </div>
</form>
